import { Component, Input, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgIf, NgClass } from '@angular/common';
import { BoomerFormsModule } from '../../shared/components/boomer-forms/boomer-forms.module';
import { MatError, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { NgxMaskDirective } from 'ngx-mask';

export type IntakeFormInputType = 'text' | 'email' | 'textarea' | 'phone';

@Component({
  selector: 'app-intake-form-input',
  standalone: true,
  imports: [ReactiveFormsModule, NgIf, BoomerFormsModule, MatError, MatIcon, MatSuffix, NgxMaskDirective],
  templateUrl: './intake-form-input.component.html',
  styleUrl: './intake-form-input.component.scss',
})
export class IntakeFormInputComponent {
  @Input()
  type: IntakeFormInputType = 'text';
  @Input()
  label: string;
  @Input('formControlInstance')
  formControl: FormControl;
  @Input()
  required: boolean;
  @Input()
  placeholder: string = 'Type your answer here...';
  @Input()
  autocomplete: AutoFill;
  @Input()
  readOnly = false;
  @Input()
  onKeydownEnter: () => void = () => {};

  @Input()
  ariaLabel: string;
}
